// extracted by mini-css-extract-plugin
export default {"paymentSection":"q4-z"};